import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { callCaravanDetailsEndpoint } from "../api";
import { StaticCaravanDTO } from "../types";

export const useGetCaravanDetails = () => {
  const { park, caravan } = useParams();

  const parkString = park ?? "";
  const caravanString = caravan ?? "";

  return useQuery<StaticCaravanDTO, Error>({
    queryKey: ["caravan-details", parkString, caravanString],
    queryFn: () => callCaravanDetailsEndpoint(parkString, caravanString),
  });
};
